import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  Paper,
  Grid,
  Typography,
  CircularProgress,
  Box,
  Tooltip,
} from '@material-ui/core';
import useGetDriverStatistics, {
  List,
} from '../../../hooks/driver/useGetDriverStatistics';

interface Driver {
  username: string;
  DELIVERED: number;
  PROBLEM_REPORTED: number;
}

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    padding: theme.spacing(2),
    backgroundColor: '#fff',
    border: '2px solid #fff',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
  },
  title: {
    fontFamily: 'Quicksand, sans-serif',
    fontSize: '1.7rem',
    color: '#1c2434',
    fontWeight: 600,
  },
  header: {
    marginBottom: '1rem',
    textAlign: 'left',
  },

  container: {
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    marginBottom: '0.2rem',
  },
  text: {
    fontFamily: 'Quicksand, sans-serif',
    fontWeight: 500,
    fontSize: '1rem',
    lineHeight: '1rem',
    color: '#1c2434',

    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  paragraph: {
    fontFamily: 'Quicksand, sans-serif',
    fontWeight: 500,
    color: '#1c2434',
    fontSize: '1rem',
    lineHeight: '1rem',
    textAlign: 'center',
  },
  progressBar: {
    position: 'absolute',
    height: '100%',
    borderRadius: '0px 4px 4px 0px',
  },
  name: {
    position: 'relative',
    zIndex: 1,
    fontWeight: 500,
    textAlign: 'left',
    marginLeft: theme.spacing(2),
  },
  progressContainer: {
    position: 'relative',
    marginRight: theme.spacing(1),
    backgroundColor: '#eff4fb',
    height: '40px',
    borderRadius: '0px 4px 4px 0px',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
  },
}));

const TableCardDrivers: React.FC = () => {
  const classes = useStyles();
  const { execute, loading } = useGetDriverStatistics();
  const [drivers, setDrivers] = useState<List[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await execute();
        setDrivers(data?.List ?? []);
      } catch (error) {
        console.error('Erro ao obter os dados:', error);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return <CircularProgress />;
  }

  return (
    <Paper className={classes.root}>
      <Typography className={classes.title} variant="h6" gutterBottom>
        Top 5 Motoristas
      </Typography>
      <Grid container spacing={1} className={classes.header}>
        <Grid item xs={6}>
          <Typography
            variant="subtitle1"
            className={classes.text}
            style={{ color: '#64748B', marginLeft: '8px' }}
          >
            Motoristas
          </Typography>
        </Grid>
        <Grid item xs={3}>
          <Typography
            variant="subtitle1"
            className={classes.paragraph}
            style={{ color: '#64748B' }}
          >
            Sucesso
          </Typography>
        </Grid>
        <Grid item xs={3}>
          <Typography
            variant="subtitle1"
            className={classes.paragraph}
            style={{ color: '#64748B' }}
          >
            Problema
          </Typography>
        </Grid>
      </Grid>
      {drivers.map((driver, index) => (
        <Grid container spacing={1} className={classes.container} key={index}>
          <Grid item xs={6}>
            <Box className={classes.progressContainer}>
              <Tooltip title={driver.username}>
                <Typography
                  className={classes.text}
                  style={{
                    marginLeft: '8px',
                    overflow: 'initial',
                    textTransform: 'uppercase',
                  }}
                >
                  {driver.username}
                </Typography>
              </Tooltip>
            </Box>
          </Grid>
          <Grid item xs={3}>
            <Typography className={classes.paragraph} variant="body1">
              {driver.DELIVERED}
            </Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography className={classes.paragraph} variant="body1">
              {driver.PROBLEM_REPORTED}
            </Typography>
          </Grid>
        </Grid>
      ))}
    </Paper>
  );
};

export default TableCardDrivers;
